import styles from "./ApplicationMessages.module.scss";
import { useHistory } from "react-router";
//Icons
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import ArrowRightIcon from "../../../../styles/icon/ArrowGray.svg";
import BellIcon from "../../../../styles/icon/Bell_fill.svg";
import { useEffect } from "react";
export default function ApplicationMessages() {
  useEffect(() => {
    let acc = document.getElementsByClassName("accordion-for-messages");
    let panel = document.getElementsByClassName("panel-buttons");

    for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function () {
        let setClasses = !this.classList.contains("active");
        setClass(acc, "active", "remove");
        setClass(panel, "show", "remove");

        if (setClasses) {
          this.classList.toggle("active");
          this.nextElementSibling.classList.toggle("show");
        }
      };
    }

    function setClass(els, className, fnName) {
      for (let i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
      }
    }
  }, []);
  const history = useHistory();
  return (
    <div className={styles.container}>
      <div className={styles.BackArrow}>
        <img
          src={ArrowBackIcon}
          alt="BACK"
          width={15}
          height={15}
          onClick={() => history.goBack()}
          className="convertPicToWhite"
        />
      </div>
      <div className={`font_color_white ${styles.title_component}`}>
        پیام ها
      </div>
      <main className={styles.container_of_messages}>
        <div className={styles.item_of_message_container}>
          <div
            className={`accordion-for-messages ${styles.subject_message_container}`}
          >
            <div className={`font_color_white ${styles.title_of_meesage}`}>
              مسابقه اینستاگرامی ارزفی
            </div>
            <div className={`font_color_white ${styles.date_of_message}`}>
              1400/5/9 -12:38
            </div>
            <div className={styles.bell_icon_container}>
              <img
                src={BellIcon}
                alt=""
                width={25}
                height={25}
                className="convertPicToGreen"
              />
            </div>
            <div className={styles.ArrowIconContainer}>
              <img
                src={ArrowRightIcon}
                alt=""
                width={15}
                height={15}
                className="convertPicToGreen"
              />
            </div>
          </div>
          <div className="panel-buttons">
            <div className={styles.text_message_container}>
              <div className={styles.line_1}></div>
              <div className={`font_color_white ${styles.textOfMessage}`}>
                جواب مسابقه رو زیر پستمون جواب بده و به قید قرعه برنده ۲۰۰ عدد
                دوج کوین شو!
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
